import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import MobilePaidProductHeader from '../../molecules/mobile-paid-product-detail-header';
import ProductRestrictions from '../../molecules/product-detail-restrictions';
import MobilePaidProductAddToCart from '../../tissues/mobile-paid-product-add-to-cart';
import MobilePaidProductDescription from '../../molecules/mobile-paid-pdp-description';
import TrustMark from '../trustmark';
import FreeGroundShipping from '../../molecules/free-ground-shipping';

const ProductInfo = styled.div`
  display: flex;
  flex-direction: column;
  grid-area: product-information;
  flex: 1;
`;

const TrustMarkWrapper = styled.div`
  display: none;
`;

const MobilePaidProductInformation = (props) => {
  const [activeVariant, setActiveVariant] = useState(null);
  const [activeVendor, setActiveVendor] = useState(null);
  const [monogramSelected, setMonogramSelected] = useState(false);

  const getInternationalShipping = () => {
    const id = activeVariant?.prices?.[0]?.vendor_id;
    const stockItem = activeVariant?.stock_items?.filter((item) => item.vendor_id === id);
    return !!stockItem?.[0]?.international_shipping;
  };

  const handleOnVariantChange = (variant) => {
    if (variant) {
      const maisonetteStockId = variant.stock_items.find((x) => x.stock_location_name === 'Maisonette Fulfillment');

      const bestMargin = variant.prices.sort((a, b) => (
        (a.price - a.offer_settings.cost_price > b.price - b.offer_settings.cost_price) ? 1 : -1
      ))[0];

      const vendor = maisonetteStockId?.vendor_id ?? bestMargin?.vendor_id;

      setActiveVariant(variant);
      setActiveVendor(vendor);
    } else {
      setActiveVariant(null);
      setActiveVendor(null);
    }
  };

  const getLeadTime = () => {
    const monogram = activeVariant?.prices?.[0]?.monogram;
    let monogramLeadTime;

    if (monogram?.monogrammable_only || (monogram && monogramSelected)) {
      monogramLeadTime = monogram?.monogram_lead_time;
    }

    return monogramLeadTime ?? activeVariant?.lead_time;
  };

  const getPrices = () => props?.product?.variants?.map((v) => v.prices[0]) ?? [];

  const noOffers = () => props?.product?.variants?.every((v) => v.price === null) ?? true;

  return (
    <ProductInfo key={props?.product?.id}>
      <MobilePaidProductHeader
        data-vwo-id="MobilePaidProductHeader"
        product={props.product}
        title={props?.product?.name}
        brand={props?.product?.brand}
        brandSlug={props?.product?.brand_slug}
        prices={getPrices()}
        noOffers={noOffers()}
        variant={activeVariant}
        vendor={activeVendor}
        slug={props?.product?.slug}
        finalSale={activeVariant?.prices?.[0]?.final_sale}
        isMobilePaid
      />

      {
          activeVariant && (
          <ProductRestrictions
            data-vwo-id="MobilePaidProductRestrictions"
            leadTime={getLeadTime()}
            importDuties={getInternationalShipping()}
          />
          )
        }

      <FreeGroundShipping product={props?.product} activeVariant={activeVariant} growthbookFeatureFlagValues={props.growthbookFeatureFlagValues} />

      <MobilePaidProductAddToCart
        product={props.product}
        position={props.position}
        variant={activeVariant}
        vendor={activeVendor}
        onVariantChange={handleOnVariantChange}
        setMonogramSelected={setMonogramSelected}
        finalSale={!!activeVariant?.prices?.[0]?.final_sale ?? false}
        meta={props.meta}
      />

      <MobilePaidProductDescription
        brand={props.product.brand}
        brandDescription={props.product.brand_description}
        description={props.product.description}
        product={props.product}
      />
      <TrustMarkWrapper data-vwo-id="MobilePaidTrustMarks">
        <TrustMark product={props.product}></TrustMark>
      </TrustMarkWrapper>
    </ProductInfo>
  );
};

MobilePaidProductInformation.defaultProps = {
  position: null,
  meta: {},
  growthbookFeatureFlagValues: {},
};

MobilePaidProductInformation.propTypes = {
  product: PropTypes.object.isRequired,
  position: PropTypes.number,
  meta: PropTypes.meta,
  growthbookFeatureFlagValues: PropTypes.object,
};

MobilePaidProductInformation.whyDidYouRender = true;

export default MobilePaidProductInformation;
